<template>
    <div>
            <h6>{{ $t('select_report_type') }}</h6>
            <div class="border rounded p-5 mb-3">
                <multiselect
                    :clear-on-select="true"
                    :close-on-select="true"
                    :deselect-label="''"
                    :options="computeRequestTypes"
                    :placeholder="$t('select')"
                    :select-label="''"
                    :selected-label="''"
                    label="text"
                    track-by="value"
                    v-model="requestType"
                />
            </div>
            <div class="col-12" v-if="requestType">
                <h6>
                    <span v-if="requestType && requestType.text">
                        {{ requestType.text }}
                    </span>
                </h6>
                <div class="border rounded p-5">
                    <component v-if="requestType && requestType.value" :is="requestType.value"/>
                </div>
            </div>
    </div>
</template>

<script>
    // Template
    // Data
    import requestTypes from './data/StudentRequestTypes'
    // Pages
    import bedHoldRequest from './pages/student/bedHoldRequest/Index'
    import requestType from './pages/student/requestType/Index'
    import roomChangeRequest from './pages/student/roomChangeRequest'
    import workOrderRequest from './pages/student/workOrderRequest/Index'
    import initialComplaint from './pages/student/initialComplaint/Index'

    export default {
        components: {
            bedHoldRequest,
            requestType,
            roomChangeRequest,
            workOrderRequest,
            initialComplaint
        },
        metaInfo() {
            return {
                title: this.$t('student_reports')
            }
        },
        data() {
            return {
                requestType: null
            }
        },
        computed: {
            computeRequestTypes() {
                return requestTypes().filter((item) => {
                    // return this.checkPermission(item.permission)
                    return item
                })
            },
            getReservationToken(){
                return this.$store.getters['roomReservationSystem/getReservationToken']
            }
        }
    }
</script>